import Request from "../../utils/Request";
import {AxiosResponse} from "axios";

const BulkEmployersUploadDetails = (file_upload_id): Promise<AxiosResponse<any>> =>
	Request.post(`/advisors/bulk-employers-upload-details/` + file_upload_id);

export default BulkEmployersUploadDetails;